/* @flow */

/**
 * Get device object from json response based on controller version available
 * @param  {object} json - Object to map data from
 * @return {object} - New object
 */
export const deviceFromGens = (json: Object) =>
  json.gen1IrrigationController ||
  json.gen2IrrigationController ||
  json.gen3IrrigationController
